<template>
  <div class="chart-conetent">
    <div class="chart-title" @click="showDetail">收支-当前ROI ></div>
    <div v-loading="chartLoading" style="height: 400px" ref="chartRef"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { getRoiTrendReport } from "@/api/bi-board";
export default {
  components: {},
  props: {
    formSearch: Object,
  },
  data() {
    return {
      chartLoading: false,
      myChart: null,
      chartData: [],
    };
  },

  computed: {},

  methods: {
    setLoading(loading) {
      this.chartLoading = loading;
    },
    getCharts() {
      this.chartLoading = true;
      const {
        formdate,
        geo,
        afid,
        platform,
        team,
        mediaList,
        accountGroupCodes,
      } = this.formSearch;
      getRoiTrendReport({
        team: team.join(",") || null,
        dateStart: formdate[0],
        dateEnd: formdate[1],
        geo: geo.join(",") || null,
        afid: afid.join(",") || null,
        platform,
        mediaList,
        accountGroupCodes: accountGroupCodes.length ? [...accountGroupCodes] : undefined,
      }).then((res) => {
        this.chartData = JSON.parse(JSON.stringify(res.data.roiTrendList));
        setTimeout(() => {
          this.myChart?.dispose();
          let chartDom = this.$refs.chartRef;
          let myChart = echarts.init(chartDom);
          window.onresize = myChart.resize;
          this.myChart = myChart;
          this.renderData();
        }, 0);
      }).catch((error) => {
        console.error('收支-当前ROI 加载失败:', error);
      }).finally(() => {
        this.chartLoading = false;
      });
    },
    renderData() {
      this.chartLoading = true;
      const maxData = Math.max(
        ...this.chartData.map((item) => item.cost),
        ...this.chartData.map((item) => item.income)
      );
      let option = {
        color: ["#a9df96", "#f2cc76", "#DC143C"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        grid: {
          left: "80",
          right: "50",
        },
        legend: {
          x: "center",
          y: "bottom",
          data: ["收入", "支出", "当前ROI"],
          itemWidth: 15,
          itemHeight: 8,
        },
        xAxis: [
          {
            type: "category",
            data: this.chartData.map((item) => item.installDay),
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              // interval: 2,
              rotate: 40, //x轴文字倾斜角度
              fontSize: 10,
              marginLeft: 22,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: maxData, // 最大值
            splitNumber: 10, // 刻度数
            interval: (maxData - 0) / 10, //强制设置刻度间隔
            axisLabel: {
              formatter: function (value) {
                return parseFloat(value.toFixed(2));
              },
            },
          },
          {
            type: "value",
            min: 0,
            splitNumber: 10,
            name: "当前ROI",
          },
        ],
        series: [
          {
            name: "收入",
            type: "bar",
            data: this.chartData.map((item) => item.income),
          },
          {
            name: "支出",
            type: "bar",
            data: this.chartData.map((item) => item.cost),
          },
          {
            name: "当前ROI",
            type: "line",
            yAxisIndex: 1,
            data: this.chartData.map((item) => item.roi),
          },
        ],
      };
      this.myChart.clear();
      this.myChart.setOption(option);
      this.chartLoading = false;
      this.myChart.resize();
    },
    showDetail() {
      this.$emit("showDetail", { title: "收支-当前ROI", key: "budgetRoi" });
    },
  },
};
</script>

<style lang="less" scoped>
.chart-conetent {
  .chart-title {
    color: rgba(0, 0, 0, 0.85);
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 0px;
    cursor: pointer;
  }
  .chart-title:hover {
    color: #1890ff;
  }
}
</style>
